// extracted by mini-css-extract-plugin
export default {"NewRulesetButton":"OverviewPage-module__NewRulesetButton--k7x1q"};